import { useLocalStorage } from 'hooks/useLocalStorage';

interface Viewer {
  id: string;
  email: string | null;
  commentsStatus: 'default' | 'pending' | 'completed';
}

export const useViewerInfo = () => {
  const [viewer, setViewer] = useLocalStorage<Viewer>('viewer', { id: '', email: '', commentsStatus: 'default' });

  const setViewerEmail = (email: string) => {
    setViewer((identifiedViewer: Viewer) => ({ ...identifiedViewer, email: email }));
  };

  const setViewerDetails = (id: string, email: string | null, commentsStatus?: 'pending' | 'completed') => {
    setViewer({ id, email: email, commentsStatus: commentsStatus || 'default' });
  };

  const clearViewerEmail = () => {
    setViewer((identifiedViewer: Viewer) => ({ ...identifiedViewer, email: '' }));
  };

  const setCommentsStatus = (commentsStatus: 'pending' | 'completed') => {
    setViewer((identifiedViewer: Viewer) => ({ ...identifiedViewer, commentsStatus }));
  };

  return { viewer, setViewerEmail, clearViewerEmail, setViewerDetails, setCommentsStatus };
};
